module.exports = __webpack_public_path__ + "img/icon-home-notice-empty-active.5c0c19d9.svg";